import React from 'react';
import './Dashboard.css';
import ActionButton from '../../partials/actions/ActionButton';
import DashboardHeader from './headers/DashboardHeader';
import HeaderCard from './headers/HeaderCard';
import StructureTable from '../../TableData/StructureTable';
import CardsTable from '../../TableData/CardsTable';
import PartnersTable from '../../TableData/PartnersTable';

function Dashboard() {
  return (
    <div className="dashboard">
      <DashboardHeader />
      
      <HeaderCard />

      <PartnersTable />

      <StructureTable />      

      <ActionButton />
    </div>
  )
}

export default Dashboard